import { ChangeEvent } from "@mcleod/components";
import { AutogenLayoutProspectFindNear } from "./autogen/AutogenLayoutProspectFindNear";
import { StringUtil } from "@mcleod/core";

export class ProspectFindNear extends AutogenLayoutProspectFindNear {
    PLOT_SETTING = "lme/dispatch/LocationFindNear.checkPlotOnMap.checked";

    override onLoad() {
        this.splitter.position = this.switchPlotOnMap.checked ? "50%" : "100%";
    }

    textboxCategoryBeforeLookupModelSearch(event) {
        event.filter.customer = 'Y';
    }

    switchShowProspectsOnMapOnChange(event: ChangeEvent) {
        const shouldPlot = this.switchPlotOnMap.checked;
        this.mapFindNear.visible = shouldPlot;
        this.mapFindNear.dataSource = shouldPlot ? this.sourceProspect : null;
        if (event.userInitiatedChange) {
            this.splitter.position = shouldPlot ? "50%" : "100%";
            this.splitter.storeUserChoiceIfRemembered();
        }
        if (shouldPlot)
            this.sourceProspect.displayDataInBoundComponents();
    }

    sourceProspectBeforeExecution(event) {
        if (event.filter.find_near_city_id == null && this.mainDataSource.searchRow.get("find_near_city_id", null) != null
            && !StringUtil.isEmptyString(this.citystateNear.textCombined.text)) {
                event.filter.find_near_city_id = this.mainDataSource.searchRow.get("find_near_city_id", null);
                event.filter.find_near_city = this.mainDataSource.searchRow.get("find_near_city", null);
                event.filter.find_near_state = this.mainDataSource.searchRow.get("find_near_state", null);
                event.filter.find_near_zip = this.mainDataSource.searchRow.get("find_near_zip", null);
        }
    }
}
